import React, { Fragment } from 'react';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import InputAdornment from '@material-ui/core/InputAdornment';

import appStyles from '../../App/app.module.css';
import cssStyles from './resetPassword.module.css';
import menuIcon from '../../assets/FD_Logo.png';
import ManualResetForm from './ManualResetForm/ManualResetForm';

import SmsCodeContainer from './SmsCodeContainer/SmsCodeContainer';
import { Check, Clear } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/Lock';
import EmailIcon from '@material-ui/icons/Email';

import { UserRoleType } from '../../models/User';

import {isPasswordSecure} from '../../utils/authentication'

interface ResetPasswordProps {
  forgottenPasswordOption: string;
  emailField: string;
  pinCode: string;
  password: string;
  companyType: UserRoleType.FORWARDER | UserRoleType.GHA;
  companies: {id: number, name: string}[];
  manualCompanyId: number;
  manualFirstName: string;
  manualLastName: string;
  confirmPassword: string;
  showSmsCodeDetails: boolean;
  showSmsDetails: boolean;
  disableCodeFields: boolean;
  showManualResetSuccessMessage: boolean;
  sendSMS: (event: any) => void;
  sendManualRequest: (event: any) => void;
  changePassword: (event: any) => void;
  onFieldChange: (event: any, value?: string) => void;
  onSmsCodeVerification: (e: any) => void;
};

const ResetPassword = (props: ResetPasswordProps) => {
  let {allTypesCharsPassword, valid, atLeast8CharPassword} = isPasswordSecure(props.password);

  return (
    <div className={ cssStyles.container }>
      <div className={ cssStyles.resetContainer }>

        <div className={ cssStyles.row }>
          <img alt="logo" src={menuIcon} className={ cssStyles.logoImg } />
          <h1 className={ cssStyles.loginHeader }>TryPod - Password Reset</h1>
        </div>

        <hr />
        <div className={ cssStyles.selectTypeContainer }>

          <span className={ cssStyles.selectTypeHeader }></span>

          <FormControl>
            <FormLabel className={ cssStyles.text }>Please select option to reset password</FormLabel>
            <RadioGroup
              name="forgottenPasswordOption"
              value={props.forgottenPasswordOption}
              onChange={props.onFieldChange}
              className={cssStyles.radioLabel}>
              <FormControlLabel value="sms" control={<Radio color="primary" />}
                label="I know my user name AND registered my cell phone at initial login" />
              <FormControlLabel value="manual" control={<Radio color="primary" />}
                label="I do not know my user name OR did not register my cell phone at initial login" />
            </RadioGroup>
          </FormControl>
        </div>
        <hr />
        {props.forgottenPasswordOption === 'sms' && (
          <div className={ cssStyles.row }>
            <div className={ cssStyles.col }>
              <form className={ appStyles.col } onSubmit={props.sendSMS} >
                <FormControl>
                  <TextField
                    id="outlined-email"
                    name='email'
                    label=""
                    margin="normal"
                    required
                    fullWidth={true}
                    value={props.emailField}
                    onChange={props.onFieldChange}
                    className={ cssStyles.textField }
                    InputProps={{ 
                      classes:{ input: cssStyles.loginInput },
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon color="primary" />
                        </InputAdornment>
                      ),
                    }}
                    placeholder="Enter your email"                
                  />
                  <Button type="submit" color="primary" variant="contained">Send SMS</Button>
                </FormControl>
              </form>
            </div>
          </div>
        )}
        {props.forgottenPasswordOption === 'manual' && (
          <ManualResetForm 
          companies={props.companies}
          companyId={props.manualCompanyId}
          companyType={props.companyType}
          firstName={props.manualFirstName}
          lastName={props.manualLastName}
          showSuccessMessage={props.showManualResetSuccessMessage}
          onFieldChange={props.onFieldChange}
          sendManualRequest={props.sendManualRequest}
          onSubmit={props.onFieldChange}/>
        )}
        <SmsCodeContainer
          onChange={props.onFieldChange}
          onVerification={props.onSmsCodeVerification}
          pin={props.pinCode}
          disableCodeFields={props.disableCodeFields}
          open={props.showSmsCodeDetails}
        />
        {props.showSmsDetails && (
          <Fragment>
            <hr />
            <div className={ cssStyles.row }>
              <form className={ cssStyles.col } onSubmit={props.changePassword} >
                <FormControl>
                  <TextField
                    name='password'
                    label=""
                    margin="normal"
                    variant="outlined"
                    required
                    type="password"
                    fullWidth={true}
                    value={props.password}
                    onChange={props.onFieldChange}
                    className={ cssStyles.textField }
                    InputLabelProps={{ 
                      shrink: true,
                      className: cssStyles.loginLabel
                    }}
                    InputProps={{ 
                      classes:{ input: cssStyles.loginInput },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon color="primary" className={ cssStyles.materialIcon }/>
                        </InputAdornment>
                      ),
                    }} 
                    placeholder="Enter the new password"
                  />
                  <TextField
                    name='confirmPassword'
                    label=""
                    margin="normal"
                    variant="outlined"
                    required
                    type="password"
                    fullWidth={true}
                    error={props.password !== props.confirmPassword}
                    value={props.confirmPassword}
                    onChange={props.onFieldChange}
                    className={ cssStyles.textField }
                    InputLabelProps={{ 
                      shrink: true,
                      className: cssStyles.loginLabel
                    }}
                    InputProps={{ 
                      classes:{ input: cssStyles.loginInput },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon color="primary" className={ cssStyles.materialIcon }/>
                        </InputAdornment>
                      ),
                    }} 
                    placeholder="Confirm the new password"
                  />
                  <br/>
                  <div className={cssStyles.passwordPolicyContainer}>
                    <div className={cssStyles.passwordPolicyHeader}>
                        Password Policy:
                    </div>
                    <div className={cssStyles.passwordPolicyConditions}>
                      {atLeast8CharPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span className={cssStyles.greyText}>Must be at least 8 characters</span>
                    </div>
                    <div className={cssStyles.passwordPolicyConditions}>
                      {allTypesCharsPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span className={cssStyles.greyText}>Must contain one upper case letter, one number and a special character</span>
                    </div>
                  </div>
                  <br/>
                  <Button type="submit" color="primary" variant="contained" disabled={props.password !== props.confirmPassword || !valid} >Change password</Button>
                </FormControl>
              </form>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;